import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.includes.js";
import React from 'react';
import { ArrowRight } from '@finect/tabular-icons/arrowRight';
import { Link } from 'react-router-dom';
import { Icon } from '../../Icon';
import { Button, IconContent, Inner, ContentBlock } from './partials';
export var Storefront = function Storefront(_ref) {
  var storefront = _ref.storefront,
    _ref$scene = _ref.scene,
    scene = _ref$scene === void 0 ? 'Storefront' : _ref$scene,
    _ref$layout = _ref.layout,
    layout = _ref$layout === void 0 ? 'vertical' : _ref$layout;
  var name = storefront.name || storefront.title;
  var link = "/invertir/".concat(storefront.alias).concat(['StorefrontList'].includes(scene) ? '/listado' : '');
  var title = "Ver m\xE1s productos de inversi\xF3n en el escaparate ".concat(name);
  return React.createElement(Inner, {
    layout: layout
  }, React.createElement(IconContent, null, React.createElement(Icon, {
    size: 3,
    type: "storefront",
    alt: name,
    image: storefront.icon ? "/image/".concat(storefront.icon) : null,
    withBorder: true,
    fill: "#fff"
  })), React.createElement(ContentBlock, null, React.createElement("h4", null, name), React.createElement(Button, {
    title: title,
    inline: true,
    primary: true,
    as: Link,
    to: link
  }, 'Ver escaparate', React.createElement(ArrowRight, {
    size: "16"
  }))));
};